<template>
    <div ref="changePasswordRef">
        <div class="login-header">
            <div><img class="medium-logo" src="../assets/DineSafeSquare.png"/></div>
            <div class="title dinesafe-purple">DineSafeVT</div>
            <div class="dinesafe-label">Change Password</div>
        </div>

        <DxValidationGroup ref="validationGroupRef">
            <div class='back-button'>
                <DxButton 
                    icon="back"
                    ref="btnBackRef" 
                    type="normal"
                    text="Back to Profile"
                    styling-mode="text" 
                    @click="btnBackToProfile"               
                />
            </div>  
            <div class="change-password-input">            
                <DxTextBox
                    name="txtCurrentPassword"
                    placeholder="Current Password"  
                    :show-clear-button="true"
                    mode="password"
                    stylingMode="underlined"
                    :value.sync="currentPassword"
                    :visible.sync="txtPasswordVisible"
                    validation-message-mode="always"
                >       
                    <DxValidator>
                        <DxRequiredRule message="Current Password is required" />
                        <DxPatternRule
                            :pattern="this.$store.state.globals.passwordPattern"
                            :message="this.$store.state.globals.passwordMessage"
                        />
                    </DxValidator>
                </DxTextBox>        
            </div>
            <div class='change-password-input'>                       
                <DxTextBox
                    name="txtNewPassword"
                    placeholder="New Password"  
                    :show-clear-button="true"
                    mode="password"
                    stylingMode="underlined"
                    :value.sync="newPassword"
                    :visible.sync="txtPasswordVisible"
                    validation-message-mode="always"
                >       
                    <DxValidator>
                        <DxRequiredRule message="New Password is required" />
                        <DxPatternRule
                            :pattern="this.$store.state.globals.passwordPattern"
                            :message="this.$store.state.globals.passwordMessage"
                        />
                    </DxValidator>
                </DxTextBox>        
            </div>
            <div class='change-password-input'>                 
                <DxTextBox
                    name="txtConfirmPassword"
                    placeholder="Confirm New Password"
                    :show-clear-button="true"
                    mode="password"
                    :value.sync="confirmPassword"
                    :visible="true"
                    validation-message-mode="always"
                >       
                    <DxValidator>
                        <DxRequiredRule message="Confirm your password" />
                        <DxCustomRule
                            :validation-callback="comparePasswords"
                            type="custom"
                            message="Passwords do not match"
                        />
                    </DxValidator>
                </DxTextBox>
            </div> 

            <div class='center save-password-button'>
                <DxButton 
                    ref="btnSavePasswordRef" 
                    type="default"
                    text="Save Password"
                    styling-mode="contained" 
                    width="180"
                    @click="btnSavePassword"
                />
            </div>
        </DxValidationGroup>
    </div>
</template>

<script>
    import {DxButton} from 'devextreme-vue';
    import DxTextBox from "devextreme-vue/text-box";
    import DxValidator, { DxRequiredRule, DxCustomRule, DxPatternRule } from "devextreme-vue/validator";
    import DxValidationSummary from 'devextreme-vue/validation-summary';
    import DxValidationGroup from "devextreme-vue/validation-group";
    import notify from 'devextreme/ui/notify';

    export default {
        components: {
            DxButton,
            DxTextBox,
            DxValidator,
            DxRequiredRule, DxCustomRule, DxPatternRule,
            DxValidationSummary,
            DxValidationGroup,
        },
        props: {
            someProp: String,
        },
        data(){
            return{
                txtPasswordVisible: true,
                currentPassword: '',
                newPassword: '',
                confirmPassword: '',
            }
        },
        methods:{
            /*
                Update the password
            */
            btnSavePassword(data) {
                console.log('btnSavePassword');

                //Validate the user inputs.
                if (!data.validationGroup.validate().isValid) {
                    return;
                }

                this.$http.post(this.$store.state.appSettings.webServiceUrl + 'ChangePassword',
                {                    
                    UserId: this.$store.state.user.userId,
                    CurrentPassword: this.currentPassword,
                    NewPassword: this.newPassword,                    
                }
                ).then(function(data){         
                    if(data.body != null && data.body != '')
                    {
                        var responseData = JSON.parse(data.body);      

                        notify(
                        {
                            message: 'Password has been updated', 
                            type:"success", 
                            width:100, 
                            displayTime: 3000,
                            position: {
                                my: 'top center',
                                at: 'top center',
                            }
                        });

                        //Navigate back to the Profile page
                        this.$router.push("/edit-user-account");

                        return; //AJT temp

                        var message = responseData[0].Message;

                        if(message == 'Success!'){
                            notify(
                            {
                                message: 'Password has been updated', 
                                type:"success", 
                                width:100, 
                                displayTime: 3000,
                                position: {
                                    my: 'center center',
                                    at: 'center center',
                                }
                            });

                            //Navigate back to the Profile page
                            this.$router.push("/edit-user-account");
                        }
                        else if(message == 'Error'){
                            notify(
                            {
                                message: 'There was an issue updating your password', 
                                type:"error", 
                                width:100, 
                                displayTime: 3000,
                                position: {
                                    my: 'center center',
                                    at: 'center center',
                                }
                            });
                        }
                    }
                });                
            },
            /*
                Navigate to the ADMIN SETTINGS page if this is an Admin user, or to the EDIT PROFILE page if this is a regular user
            */
            btnBackToProfile(data, actions) {
                if(this.$store.state.user.isAdmin)
                {
                    this.$router.push("/admin");    
                }
                else
                {
                    this.$router.push("/edit-user-account");
                }
            },
            
            /*
                Check if the passwords match
            */
            comparePasswords(e) {
                //console.log("comparePasswords");

                //Check if the value for the Password matches the value for Confirm Password
                return this.newPassword == this.confirmPassword;
            },
        }
    }
</script>

<style scoped>
  @import '../themes/contact-tracing.css';
  
    .change-password-input{
        padding-bottom: 25px;
        padding-top:10px;

        margin:auto;
        max-width: 400px;
    }

  .save-password-button{
    padding-top:20px;
  }

</style>
